// create a page having two input fields - restaurent Id and location Id
// on submit, redirect to /:restaurentId/:locationId
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from "react-router-dom";
import { login } from '../../redux/action';
import AdminHome from "../../pages/AdminHome";
import './main.css'

function Main() {
    const [locationId, setLocationId] = useState('');
    const [selectedUserId, setSelectedUserId] = useState('');
    //const restros = {restaurantOrBranchId: 'qwerrtghh', userId:22, restaurantOrBranchName: 'ark', address:'BTM'}
    const restros = useSelector((state) => state.user?.restros);

    const location = useLocation();
    // const restros = location.state?.restros || [];
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const hasRestros = restros && Object.keys(restros).length > 0;

    useEffect(() => {
        const wrapper = document.querySelector(".layout-wrapper");

        if (wrapper) {
            if (hasRestros) {
                wrapper.classList.add("no-sidebar");
            } else {
                wrapper.classList.remove("no-sidebar");
            }
        }
    }, [hasRestros]);


    console.log("Main page loaded with restros:", restros);
    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("submit", selectedUserId);
        if (selectedUserId) {
            dispatch(login({ selectedUserId }));
            //navigate(`/${'userId'}/${'restaurantOrBranchId'}/`);
        }
    }


    return (

        restros ? <div className="mainContainer no-sidebar">
            <h2 className="hide">Main Page</h2>
            <form onSubmit={handleSubmit} className="mainForm">
                <div className="formGroup">
                    <label htmlFor="selectedUserId">Restaurent:</label>
                    {/* <input type="text" id="restaurentId" value={restaurentId} onChange={(e) => setRestaurentId(e.target.value)} required /> */}
                    <select
                        id="selectedUserId"
                        value={selectedUserId}
                        onChange={(e) => setSelectedUserId(e.target.value)}
                        style={styles.select}
                        required
                    >
                        <option value="">Select a restaurant</option>
                        {Object.values(restros).map((r) => (
                            <option key={r.restaurantOrBranchId} value={r.userId}>
                                {r.restaurantOrBranchName} - {r.address}
                            </option>
                        ))}
                    </select>
                </div>
                {/* <div className="formGroup">
                <label htmlFor="locationId">Location ID:</label>
                <input type="text" id="locationId" value={locationId} onChange={(e) => setLocationId(e.target.value)} required />
            </div> */}
                <button type="submit" className="submitButton">Go to Menu</button>
            </form>
        </div> : <AdminHome />
    );
}
const styles = {
    select: {
        width: '100%',
        padding: '10px',
        border: '1px solid #ccc',
        borderRadius: '4px',
        boxSizing: 'border-box',
        backgroundColor: '#fff',
    }
}
export default Main;